module.exports = __webpack_public_path__ + "static/media/submitInputData.bf90be0a.svg";